import React from 'react'
import RawHTML from 'react-dom'

export default function SplitTextToSpans({children}) {
  if(!children) return null

  const splitIntoSpans = (text) => {
    const regex = /(<[^>]+>)|([^<\s]+)/g
    let chunks = [],
      currentChunk = [],
      currentLength = 0,
      wordCount = 0,
      isHTML = false

    function addCurrent () {
      isHTML = false
      chunks.push(currentChunk.join(' '))
      currentChunk = []
      currentLength = 0
      wordCount = 0
    }

    text.match(regex).forEach((segment) => {
      if(isHTML) {

        currentChunk.push(segment)

        if(segment.match(/^<.*>$/)) {
          addCurrent()
        }

      } else if(segment.match(/^<.*>$/)) {

        isHTML = true

        if(currentChunk.length) {
          addCurrent()
        }
        currentChunk.push(segment)

      } else {

        currentChunk.push(segment)
        currentLength += segment.length + 1
        if(segment.length > 3) {
          wordCount++
        }
        if(wordCount === 3 || currentLength >= 18) {
          addCurrent()
        }

      }
    })

    if(currentChunk.length) {
      chunks.push(currentChunk.join(' '))
    }
    console.log(chunks[0],chunks[0].match(/<b>/))

    return chunks.map((chunk, index) => (
      (chunk.match(/<b>/)) ?
        <span className={"text-grad-highlight"} key={index} dangerouslySetInnerHTML={{__html: chunk + " "}}/>
        :
        <span className={"text-grad-grey"} key={index} dangerouslySetInnerHTML={{__html: chunk + " "}}/>
    ))
  }

  return <>{splitIntoSpans(children)}</>
}